import API from './Api';

class OrderAPI extends API {
    constructor() {
        super('/orders');
    }
}

export default OrderAPI;
